<template>
    <v-card
        :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        elevation="0"
        class="all-trade-tab rounded-0"
    >
        <v-tabs
            :background-color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
            v-model="model"
        >
            <v-tab class="px-0 ml-0" :href="`#tab-1`"> All </v-tab>
            <v-tab :href="`#tab-2`"> Live Account </v-tab>
            <v-tab :href="`#tab-3`"> My Investor Account </v-tab>
            <v-tab :href="`#tab-4`"> My Manager Account </v-tab>
            <v-tab :href="`#tab-5`"> Demo </v-tab>
            <v-tabs-items v-model="model">
                <v-tab-item :value="`tab-1`">
                    <all-tabs></all-tabs>
                </v-tab-item>
                <v-tab-item :value="`tab-2`">
                    <live-account-tab></live-account-tab>
                </v-tab-item>
                <v-tab-item :value="`tab-3`">
                    <my-investor-account-tab></my-investor-account-tab>
                </v-tab-item>
                <v-tab-item :value="`tab-4`">
                    <manage-investor-account-tab></manage-investor-account-tab>
                </v-tab-item>
                <v-tab-item :value="`tab-5`">
                    <demo-account-tab></demo-account-tab>
                </v-tab-item>
            </v-tabs-items>
        </v-tabs>
    </v-card>
</template>
<script>
import AllTabs from "./AllTabs.vue";
import DemoAccountTab from "./DemoAccountTab.vue";
import LiveAccountTab from "./LiveAccountTab.vue";
import ManageInvestorAccountTab from "./ManageInvestorAccountTab.vue";
import MyInvestorAccountTab from "./MyInvestorAccountTab.vue";

export default {
    data() {
        return {
            tab: null,
            model: "tab-4",
        };
    },
    components: {
        AllTabs,
        LiveAccountTab,
        MyInvestorAccountTab,
        ManageInvestorAccountTab,
        DemoAccountTab,
    },
};
</script>

LiveAccountTab
